<template>
  <div id="app">
    <AuthPrompt/>
    <Header/>
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
import Header from "./components/components/header/Header";
import AuthPrompt from "./components/components/auth/AuthPrompt";

export default {
  components: {
    Header,
    AuthPrompt,
  },
};
</script>

<style>
@import "../node_modules/bulma/css/bulma.css";
@import "./styles/main.css";
@import "./styles/cards.css";
</style>
